import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import CalculatorPage from "./pages/CalculatorPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminEntriesPage from "./pages/AdminEntriesPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

function App() {
    return (
        <div className="App" translate="no">
            <BrowserRouter>
                <Toaster
                    position="top-center"
                    toastOptions={{
                        style: {
                            border: "2px solid #09090B",
                            borderRadius: 0,
                            background: "#FFFFFF",
                            color: "#09090B",
                            fontFamily: "IBM Plex Sans, sans-serif",
                        },
                    }}
                />
                <Routes>
                    <Route path="/" element={<CalculatorPage />} />
                    <Route path="/admin" element={<AdminLoginPage />} />
                    <Route path="/admin/entries" element={<AdminEntriesPage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
